<template>
  <el-row :gutter="20">
      <div class="title-h3 mr-b10">필터 목록</div>
      <el-table-wrapper :column-default="columnDefault" row-class-name="c-dblclick" :data="baseLineFilterData" :columns="baseLineFilterColumns" :pagination="true"
        :show-custom-header="false" header-align="center" highlight-current-row  @cell-dblclick="showBaseLineSettingPopup" @condition-change="setTableParameter">
        <template slot-scope="scope" slot="stats-period-slot">
          {{ scope.row.statsPeriod }}개월
        </template>
        <template slot-scope="scope" slot="upper-bound-slot">
          +{{ scope.row.upperBound }}%
        </template>
        <template slot-scope="scope" slot="lower-bound-slot">
          -{{ scope.row.lowerBound }}%
        </template>
        <template slot-scope="scope" slot="logAvg-slot">
          {{ convertValue(scope.row.logAvg) }}개
        </template>
        <template slot-scope="scope" slot="total-slot">
          {{ convertValue(scope.row.total) }}개
        </template>
        <template slot-scope="scope" slot="reset-baseline-slot">
          <el-button @click="resetBaseline(scope.row.filterId)"><i class="fas fa-history"></i></el-button>
        </template>
      </el-table-wrapper>
      <w-base-line-rule-setting-popup ref="baseLineRulePopup" @loadData="loadFilterData" :selectFilter="selectFilter"></w-base-line-rule-setting-popup>
  </el-row>
</template>

<script>
import { columnDefault } from '@/constants/table';
import BaselineAPI from '@/api/settings/log/lms-baseline-setting';
import { convertValuByUnit } from '@/utils/number';
import msgUtil from '@/utils/message';
import WBaseLineRuleSettingPopup from '../popup/BaseLineRuleSettingPopup';


export default {
  components: {
    WBaseLineRuleSettingPopup,
  },
  data() {
    return {
      limit: 50,
      start: 0,
      searchParams: null,
      selectedFilterGroup: '',
      selectFilter: {},
      columnDefault,
      baseLineFilterData: [],
      baseLineFilterColumns: [
        {
          label: '필터명',
          prop: 'filterName',
        },
        {
          label: '통계 기간',
          prop: 'statsPeriod',
          scopedSlot: 'stats-period-slot',
        },
        {
          label: '상한',
          prop: 'upperBound',
          scopedSlot: 'upper-bound-slot',
        },
        {
          label: '하한',
          prop: 'lowerBound',
          scopedSlot: 'lower-bound-slot',
        },
        {
          label: '하루 평균',
          prop: 'logAvg',
          scopedSlot: 'logAvg-slot',
        },
        {
          label: '총 발생 횟수',
          prop: 'total',
          scopedSlot: 'total-slot',
        },
        {
          label: '데이터 초기화',
          scopedSlot: 'reset-baseline-slot',
          width: 100,
          align: 'center',
          headerAlign: 'center',
        },
      ],
    };
  },
  methods: {
    setTableParameter(value) {
      this.limit = value.limit;
      this.start = value.start;
      this.searchParams = value.searchParams;
      this.loadFilterData();
    },
    /**
     * 숫자 단위 설정 함수
     * @author leesy918
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    convertValue(value) {
      return `${convertValuByUnit(Number(value), 'count', true, false, true)}`;
    },
    resetBaseline(filterId) {
      this.$confirm(...msgUtil.getCustomConfirmData('베이스 라인을 초기화 하시겠습니까?')).then(() => {
        const params = {
          filterId,
        };
        BaselineAPI.resetBaselineData(params).then((response) => {
          if (response.data.success) {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SET, '초기화', true));
            this.loadFilterData();
          } else {
            this.$message(msgUtil.getResultMsgData(msgUtil.action.SET, '초기화', false));
          }
        }).catch((e) => {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SET, '초기화', false));
          throw new Error(e);
        });
      });
    },
    /**
     * 필터 그룹 선택 시 작동 함수
     * @author leesy918
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    selectFilterGroup(row) {
      this.limit = 50;
      this.start = 0;
      this.searchParams = null;
      this.selectedFilterGroup = row;
      this.loadFilterData(this.selectedFilterGroup);
    },

    /**
     * 필터 목록 조회
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    loadFilterData() {
      const params = this.selectedFilterGroup;
      params.limit = this.limit;
      params.start = this.start;
      params.searchParams = this.searchParams;
      BaselineAPI.getFilterList(params).then((response) => {
        if (response.data.success) {
          this.baseLineFilterData = response.data.data;
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '필터 목록', false));
        throw new Error(e);
      });
    },
    showBaseLineSettingPopup(data) {
      this.selectFilter = data;
      this.$refs.baseLineRulePopup.open();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Alarm/components/LogBaselineTable.vue